import { useIntl } from 'react-intl';
import { foundation } from '../../../ui';
import useReducedMotion from '../../../hooks/ai/useReducedMotion';
import MfaSuccessMark, { mfaRiseStyle } from './MfaSuccessMark';
import AuthFieldMessage from '../AuthFieldMessage';
import { mfaDoneColumnStyle, mfaDoneTitleStyle } from './mfaStyles';

const f = foundation;
const fc = f.color;

const summaryStyle = { width: '100%', marginTop: f.spacePx[5], border: `1px solid ${fc.neutral.border}`, borderRadius: f.radii.md, overflow: 'hidden', textAlign: 'left' };
const rowStyle = { display: 'flex', alignItems: 'center', gap: f.spacePx[3], padding: `${f.spacePx[3]} ${f.spacePx[3]}`, borderTop: `1px solid ${fc.neutral.border}`, fontSize: f.fontSize.sm, fontFamily: f.fontFamily.sans };
const keyStyle = { flex: 1, color: fc.neutral.textSecondary };
const valStyle = { fontWeight: f.fontWeight.bold, color: fc.neutral.text };

/**
 * RD-SEC-015 flow I — the closing summary, as a centered success moment:
 * `MfaSuccessMark` draws its ring then the check, the title rises in after
 * it, and the summary card sits 20px below. Pure CSS timing (never gated on
 * `animationend`); reduced motion renders it all static. `codesCount`
 * reflects the number actually issued — 0 if `mfa-recovery-codes` failed
 * (never fabricated as 10). `codesFailed` adds an inline note under the
 * summary that points at Security → Get new codes, so a bare 0 is explained.
 */
export default function MfaStepDone({ issuer, codesCount, codesFailed = false }) {
  const intl = useIntl();
  const reducedMotion = useReducedMotion();

  return (
    <div style={mfaDoneColumnStyle}>
      <MfaSuccessMark tone="success" />
      <p style={{ ...mfaDoneTitleStyle, ...mfaRiseStyle(reducedMotion) }}>{intl.formatMessage({ id: 'mfaStepper.done.title', defaultMessage: 'Done! Your account is protected' })}</p>
      <div style={summaryStyle}>
        <div style={{ ...rowStyle, borderTop: 'none' }}>
          <span style={keyStyle}>{intl.formatMessage({ id: 'mfaStepper.done.app', defaultMessage: 'App' })}</span>
          <span style={valStyle}>{issuer}</span>
        </div>
        <div style={rowStyle}>
          <span style={keyStyle}>{intl.formatMessage({ id: 'mfaStepper.done.codes', defaultMessage: 'Recovery codes' })}</span>
          <span style={valStyle}>{codesCount}</span>
        </div>
        <div style={rowStyle}>
          <span style={keyStyle}>{intl.formatMessage({ id: 'mfaStepper.done.atSignIn', defaultMessage: 'At sign-in' })}</span>
          <span style={valStyle}>{intl.formatMessage({ id: 'mfaStepper.done.atSignInVal', defaultMessage: 'Password + code' })}</span>
        </div>
      </div>
      {codesFailed ? (
        <div style={{ width: '100%', marginTop: f.spacePx[3], textAlign: 'left' }}>
          <AuthFieldMessage
            tone="warning"
            testId="mfa-done-codes-failed"
            message={intl.formatMessage({
              id: 'mfaStepper.done.codesFailed',
              defaultMessage: 'Your recovery codes were not shown. Try generating new codes later in Security → Get new codes.',
            })}
          />
        </div>
      ) : null}
    </div>
  );
}
